<template>
  
</template>

<script>
export default {
  name: "HelloWorld",
  props: {}
};
</script>


<style scoped>

</style>
